<section class="w-100 p-4 p-xl-5">
  <div class="container">
    <div class="h-100">
      <div
        class="row d-flex justify-content-center align-items-center mb-5 mt-3"
      >
        <img
          src="../../assets/images/GD_Logotipo_UI.png"
          alt="login form"
          class="logo"
          style="border-radius: 1rem 0 0 1rem"
        />
      </div>

      <div *ngIf="isGoogleAuthEnabled" class="mb-4">
        <button
          type="button"
          class="btn btn-outline-dark btn-lg w-100"
          [disabled]="isLoading"
          (click)="continueWithGoogle()"
        >
          <gd-inline-spinner
            *ngIf="isLoading"
            class="me-2"
            size="sm"
            tone="current"
          />
          <i *ngIf="!isLoading" class="bi bi-google me-2"></i>
          Continuar con Google
        </button>
      </div>

      <div
        *ngIf="isGoogleMode && googleIdentity as identity"
        class="d-flex align-items-center gap-3 border rounded p-3 mb-4"
      >
        <img
          *ngIf="identity.photoUrl; else googleAvatarPlaceholder"
          [src]="identity.photoUrl"
          class="rounded-circle object-fit-cover"
          width="48"
          height="48"
          alt="Cuenta de Google vinculada"
        />
        <ng-template #googleAvatarPlaceholder>
          <i class="bi bi-person-circle fs-1 text-muted"></i>
        </ng-template>
        <div class="flex-grow-1 overflow-hidden">
          <div class="fw-semibold text-truncate">
            {{ identity.displayName }}
          </div>
          <div class="small text-muted text-truncate">
            {{ identity.email }}
          </div>
        </div>
        <button
          gdClarityUnmask
          type="button"
          class="btn btn-link btn-sm"
          [disabled]="isLoading"
          (click)="continueWithGoogle()"
        >
          Cambiar
        </button>
      </div>

      <mat-stepper [linear]="isLinear" #stepper>
        <mat-step [stepControl]="companyForm">
          <form [formGroup]="companyForm" class="row w-100">
            <ng-template matStepLabel>Datos del taller</ng-template>
            <h4 gdClarityUnmask class="my-3">Datos del taller</h4>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Razón social</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="companyNameControl"
                  required
                />
                <mat-error
                  *ngFor="let error of companyNameControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <gd-location-selector
                [cityControl]="companyCityControl"
                [provinceControl]="companyProvinceControl"
              >
              </gd-location-selector>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="companyAddressControl"
                  required
                />
                <mat-error
                  *ngFor="let error of companyAddressControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="companyPhoneControl"
                  required
                />
                <mat-error
                  *ngFor="let error of companyPhoneControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  formControlName="companyEmailControl"
                  required
                />
                <mat-error
                  *ngFor="let error of companyEmailControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-outline mb-4">
              <mat-label>Logo </mat-label>
              <input
                type="file"
                (change)="onFileChange($event)"
                class="form-control form-control-lg"
              />
              <mat-error
                *ngFor="let error of companyLogoControl.errors | keyvalue"
              >
                {{ error | controlErrorMessage }}
              </mat-error>
            </div>
            <div class="d-flex justify-content-end">
              <button gdClarityUnmask mat-button matStepperNext>
                Siguiente
              </button>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="userForm">
          <form [formGroup]="userForm" class="row w-100">
            <ng-template matStepLabel>Datos usuario</ng-template>
            <h4 gdClarityUnmask class="my-3">
              Datos del usuario administrador
            </h4>

            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="userNameControl"
                  required
                />
                <mat-error
                  *ngFor="let error of userNameControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Correo</mat-label>
                <input
                  matInput
                  type="email"
                  formControlName="userEmailControl"
                  required
                />
                <mat-error
                  *ngFor="let error of userEmailControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col" *ngIf="!isGoogleMode">
              <mat-form-field appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  formControlName="userPasswordControl"
                  required
                />

                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="
                    hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'
                  "
                >
                  <mat-icon>{{
                    hidePassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error
                  *ngFor="let error of userPasswordControl.errors | keyvalue"
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Confirmar contraseña</mat-label>
                <input
                  matInput
                  [type]="hideConfirmPassword ? 'password' : 'text'"
                  formControlName="userConfirmPasswordControl"
                  required
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                  [attr.aria-label]="
                    hideConfirmPassword
                      ? 'Mostrar contraseña'
                      : 'Ocultar contraseña'
                  "
                >
                  <mat-icon>{{
                    hideConfirmPassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error
                  *ngFor="
                    let error of userConfirmPasswordControl.errors | keyvalue
                  "
                >
                  {{ error | controlErrorMessage }}
                </mat-error>
              </mat-form-field>
              <mat-hint align="start">
                <p [innerHTML]="passwordHint"></p>
              </mat-hint>
            </div>

            <div class="d-flex justify-content-end">
              <button gdClarityUnmask mat-button matStepperPrevious>
                Volver
              </button>
              <button gdClarityUnmask mat-button matStepperNext>
                Siguiente
              </button>
            </div>
          </form>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Revisión</ng-template>
          <h4 gdClarityUnmask>Revisá todos los datos ingresados!</h4>
          <div class="row">
            <div
              class="col my-4 w-100 d-flex justify-content-center"
              *ngIf="selectedFile"
            >
              <img
                class="avatar"
                [src]="selectedFile"
                alt="Vista previa del logo de la compañía"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5 gdClarityUnmask>Compañía</h5>
              <div class="d-flex flex-column">
                <span>
                  <strong>Nombre: </strong>
                  <span>{{ companyForm.value.companyNameControl }}</span>
                </span>
                <span>
                  <strong>Dirección: </strong>
                  <span>{{ companyForm.value.companyAddressControl }}</span>
                </span>
                <span>
                  <strong>Teléfono: </strong>
                  <span>{{ companyForm.value.companyPhoneControl }}</span>
                </span>
              </div>
            </div>
            <div class="col">
              <h5 gdClarityUnmask>Usuario Admin</h5>
              <div class="d-flex flex-column">
                <span>
                  <strong>Nombre: </strong>
                  <span>{{ userForm.value.userNameControl }}</span>
                </span>
                <span>
                  <strong>Correo: </strong>
                  <span>{{ userEmailControl.value }}</span>
                </span>
              </div>
            </div>
          </div>

          <div class="row pt-1 mb-4 text-end">
            <gd-button
              buttonType="submit"
              (buttonClick)="onRegister()"
              classes="w-100 mt-4"
              label="{{ isLoading ? 'Registrando...' : 'Registrar' }}"
              [isLoading]="isLoading"
            ></gd-button>
            <gd-button
              classes="w-100 mt-3"
              (buttonClick)="resetFroms()"
              colorType="secondary"
              label="Cancelar"
            ></gd-button>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
  <p class="small text-muted text-center mt-5">
    Ya tienes una cuenta?
    <a class="small" routerLink="/login">Iniciar sesión</a>
  </p>
</section>
